import { defineStore } from 'pinia'



export const useErrorStore = defineStore({
  id: 'error',
  state: () => ({
    data: {
      data:
      {
        errors: {
          error: [
            'Неизвестная ошибка приложения, обновите и попробуйте еще раз или свяжитесь с поддержкой'
          ]
        }
      }
    },
  }),

  actions: {
    reset_errors() {
      this.$patch({
        data: '12345'
      })
      console.log(this.data)
    },
    create_errors(data) {

      this.$patch({
        data: data
      })
    }


  }
})
